import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ReportsSchema = withDefaults({
  type: 'report',
  objectExtensions: ['report'],
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'reportType',
    },
    {
      kind: 'attribute',
      name: 'searchConfig',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'attribute',
      name: 'partnerAccessConfig',
    },
    {
      kind: 'attribute',
      name: 'visibilityLevel',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
  ],
});

export default ReportsSchema;
